import { useState, useRef } from 'react';
// Removed unused AnimatePresenceProps import

interface AnimatedItemData {
  content: React.ReactNode;
  isHidden?: boolean;
  exitReason?: 'favorite' | 'dismiss'; // ✅ AJOUT : Transmettre exitReason
  [key: string]: any;
}

interface AnimatedItem {
  id: string;
  data: AnimatedItemData;
  isExiting?: boolean; // ✅ NOUVEAU : Marquer les éléments en cours de sortie
}

interface AnimationConfig {
  exitDuration?: number;
}

export const useAnimatedList = (
  rawItems: { id: string; content: React.ReactNode; isHidden?: boolean; exitReason?: 'favorite' | 'dismiss' }[], // ✅ AJOUT : exitReason dans l'interface
  config: AnimationConfig = { exitDuration: 300 }
) => {
  // Transformer les items au format attendu
  const items = rawItems.map(item => ({
    id: item.id,
    data: {
      content: item.content,
      isHidden: item.isHidden,
      exitReason: item.exitReason // ✅ AJOUT : Transmettre exitReason
    }
  }));

  // ✅ FIX REALTIME : Signature stable basée sur les IDs
  const currentSignature = items.map(item => item.id).join(',');

  const [visibleItems, setVisibleItems] = useState<AnimatedItem[]>([]);
  const lastSignatureRef = useRef<string>('');
  const isInitializedRef = useRef(false);

  // ✅ FIX : Synchronisation immédiate (pas dans useEffect pour éviter boucle infinie)
  // Utiliser une approche synchrone avec refs pour tracker les changements
  if (!isInitializedRef.current && items.length > 0) {
    // Premier rendu avec des items
    isInitializedRef.current = true;
    lastSignatureRef.current = currentSignature;
    // Mise à jour immédiate via setState initial
    if (visibleItems.length === 0) {
      // Note: Ceci déclenchera un re-render mais c'est nécessaire pour initialiser
      setVisibleItems(items.map(item => ({ ...item, isExiting: false })));
    }
  } else if (isInitializedRef.current) {
    const structureChanged = lastSignatureRef.current !== currentSignature;

    if (structureChanged) {
      // Structure a changé (ajout/suppression d'items)
      lastSignatureRef.current = currentSignature;
      // Comparaison avec visibleItems actuel pour éviter mise à jour inutile
      const currentVisibleIds = visibleItems.map(item => item.id).join(',');
      if (currentVisibleIds !== currentSignature) {
        setVisibleItems(items.map(item => ({ ...item, isExiting: false })));
      }
    }
    // ✅ NOTE: Le contenu est mis à jour via items directement dans le return
  }

  // ✅ FIX REALTIME : Retourner items directement pour avoir le contenu à jour
  // Tout en gardant la structure de visibleItems pour les animations
  const animatedItems = visibleItems.length > 0
    ? visibleItems.map((visItem, index) => ({
        ...visItem,
        data: items[index]?.data || visItem.data // ✅ Contenu toujours à jour
      }))
    : items.map(item => ({ ...item, isExiting: false }))

  const getMotionProps = (itemId: string) => ({
    initial: { opacity: 0, y: 50 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -50 },
    transition: { duration: config.exitDuration || 300 }
  });

  return {
    animatedItems, // ✅ FIX: Utiliser animatedItems avec contenu à jour
    getMotionProps
  };
}; 